import { render, staticRenderFns } from "./ServiceTypezhongfeng3month.vue?vue&type=template&id=625b8422&scoped=true"
import script from "./ServiceTypezhongfeng3month.vue?vue&type=script&lang=js"
export * from "./ServiceTypezhongfeng3month.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b8422",
  null
  
)

export default component.exports